import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { useSettingsNavigate } from '@frontend/settings-routing';
import { theme } from '@frontend/theme';
import { BannerNotification, Text, TextLink } from '@frontend/design-system';
import { useAppStatus } from '../../../../../providers/app-status.provider';
import { Section } from '../../../layout/section';

export const HealthStatusSection = () => {
  const navigate = useSettingsNavigate();
  const { t } = useTranslation();
  const { websocket, ipc } = useAppStatus();
  const errorPath = '/personal/diagnostics';
  let errorMessage: string | null = null;
  if (ipc?.state === 'error') errorMessage = t('There is a problem connecting to notifications!');
  else if (websocket?.state === 'error') errorMessage = t('There is a problem connecting to the websocket server!');
  if (!errorMessage) return null;
  return (
    <Section>
      <Text
        size='large'
        weight='bold'
        css={css`
          margin-bottom: ${theme.spacing(1)};
        `}
      >
        {t('System Health Alerts')}
      </Text>
      <BannerNotification
        status='warn'
        css={css`
          margin-bottom: ${theme.spacing(1)};
        `}
      >
        <Text
          css={css`
            display: flex;
            justify-content: space-between;
            gap: ${theme.spacing(2)};
          `}
        >
          <span>{errorMessage}</span>
          <TextLink onClick={() => navigate.navigate({ to: errorPath })}>{t('More')}</TextLink>
        </Text>
      </BannerNotification>
    </Section>
  );
};
